
import {AiOutlineArrowRight} from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'
const Card = ({image, title, slug}) =>{

    const router = useNavigate()

    const blockClickHandler = () => {
        // console.log("mehhhhhhh")
        router(`/blog/${slug}`)
    }

    return (
        <div className="w-full sm:w-[27%] flex flex-col justify-around gap-5">
            {/*<div className="card-body">*/}
                <img className='w-full' src={image}/>
                <h5 className="text-2xl sm:text-2xl font-semibold text-primary-100">{title}</h5>
                {/*<p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>*/}
            <div onClick={blockClickHandler} className='flex justify-start gap-1 items-center underline'>
                <button className="text-xl text-[#006395] font-semibold">Read More</button>
                <AiOutlineArrowRight className='mt-1 text-xl font-bold text-[#006395]' />
            </div>
            {/*</div>*/}
        </div>
    )
}

export default Card


